import { createContext } from 'react'
import type { AuthUser, LoginInput } from '../model/contracts'

export interface AuthContextValue {
  user: AuthUser | null
  isLoading: boolean
  isAuthenticated: boolean
  isLoginPending: boolean
  isLogoutPending: boolean
  loginWithPassword: (input: LoginInput) => Promise<AuthUser>
  logoutUser: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | null>(null)
